import { useLocation } from 'react-router-dom';

const ROUTE_BY_PAGE = {
  trips: '/',
  charts: '/charts',
  maps: '/maps',
  bucket: '/bucket',
  portal: '/portal-plan',
};

/** Only fetch page-specific assignment bundles when that route is active. */
export function useAssignmentRouteEnabled(page) {
  const { pathname } = useLocation();
  const target = ROUTE_BY_PAGE[page];
  if (!target) return false;
  if (target === '/') return pathname === '/';
  return pathname === target || pathname.startsWith(`${target}/`);
}
